module.exports = __webpack_public_path__ + "img/caseboxItem.3a93ca1f.png";